import i18next from 'i18next';
import { displaySuccess } from '_template';

export const notifySaveSuccess = () => {
  displaySuccess(i18next.t('FORM.RECORD_SAVED'));
};
